/**
 * @generated SignedSource<<e6d67457203585c453e6a0edaa928b60>>
 * @relayHash 0a9cfabdd2706cea4a3cc2af5fbf0560
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0a9cfabdd2706cea4a3cc2af5fbf0560

import type { ConcreteRequest } from 'relay-runtime';
export type IssueClosedStateReason = "COMPLETED" | "DUPLICATE" | "NOT_PLANNED" | "%future added value";
export type IssueState = "CLOSED" | "OPEN" | "%future added value";
export type UpdateIssuesBulkByQueryInput = {
  addToProjectV2Ids?: ReadonlyArray<string> | null | undefined;
  applyAssigneeIds?: ReadonlyArray<string> | null | undefined;
  applyLabelIds?: ReadonlyArray<string> | null | undefined;
  clearMilestone?: boolean | null | undefined;
  clientMutationId?: string | null | undefined;
  issueTypeId?: string | null | undefined;
  milestoneId?: string | null | undefined;
  query: string;
  removeAssigneeIds?: ReadonlyArray<string> | null | undefined;
  removeFromProjectV2Ids?: ReadonlyArray<string> | null | undefined;
  removeLabelIds?: ReadonlyArray<string> | null | undefined;
  repositoryId: string;
  state?: IssueState | null | undefined;
  stateReason?: IssueClosedStateReason | null | undefined;
  unsetIssueType?: boolean | null | undefined;
};
export type updateIssueAssigneesBulkByQueryMutationSharedMutation$variables = {
  input: UpdateIssuesBulkByQueryInput;
};
export type updateIssueAssigneesBulkByQueryMutationSharedMutation$data = {
  readonly updateIssuesBulkByQuery: {
    readonly jobId: string | null | undefined;
  } | null | undefined;
};
export type updateIssueAssigneesBulkByQueryMutationSharedMutation$rawResponse = {
  readonly updateIssuesBulkByQuery: {
    readonly jobId: string | null | undefined;
  } | null | undefined;
};
export type updateIssueAssigneesBulkByQueryMutationSharedMutation = {
  rawResponse: updateIssueAssigneesBulkByQueryMutationSharedMutation$rawResponse;
  response: updateIssueAssigneesBulkByQueryMutationSharedMutation$data;
  variables: updateIssueAssigneesBulkByQueryMutationSharedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateIssuesBulkByQueryPayload",
    "kind": "LinkedField",
    "name": "updateIssuesBulkByQuery",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jobId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateIssueAssigneesBulkByQueryMutationSharedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateIssueAssigneesBulkByQueryMutationSharedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "0a9cfabdd2706cea4a3cc2af5fbf0560",
    "metadata": {},
    "name": "updateIssueAssigneesBulkByQueryMutationSharedMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "754272a12989fa5f92464aef8e29d002";

export default node;
